import Swal from 'sweetalert2';
import { makePDF } from '~core/makePDF';

const printFrameId = 'giotto-print-frame';

// Se l'estensione Adobe Acrobat fa da visualizzatore PDF, il PDF aperto in una
// nuova scheda ignora la stampa automatica. Acrobat non gestisce i PDF
// incorporati: in un riquadro della pagina resta il visualizzatore di Chromium.
const canPrintFromFrame = () => {
  const { brands = [], mobile = true } = navigator.userAgentData || {};
  return !mobile && brands.some(({ brand }) => brand === 'Chromium');
};

const offerToOpenPdf = async (pdfUrl) => {
  const { isConfirmed } = await Swal.fire({
    title: 'Stampa non avviata',
    text:
      'Il browser non ha aperto la finestra di stampa. Apri il PDF e stampalo da lì.',
    icon: 'error',
    showCancelButton: true,
    confirmButtonText: 'Apri il PDF',
    cancelButtonText: 'Annulla',
    confirmButtonColor: '#278e8e',
  });

  if (isConfirmed) {
    window.open(pdfUrl, '_blank');
  }
};

const printFromFrame = (pdfUrl) => {
  const previousFrame = document.getElementById(printFrameId);
  if (previousFrame) {
    URL.revokeObjectURL(previousFrame.src);
    previousFrame.remove();
  }

  const frame = document.createElement('iframe');
  frame.id = printFrameId;
  frame.style.cssText =
    'position: fixed; left: -10000px; top: 0; width: 400px; height: 600px; border: 0;';
  frame.addEventListener(
    'load',
    () => {
      try {
        frame.contentWindow.print();
      } catch (error) {
        console.error(error);
        offerToOpenPdf(pdfUrl);
      }
    },
    { once: true }
  );
  frame.src = pdfUrl;
  document.body.appendChild(frame);
};

export const printPDF = async () => {
  const pdf = await makePDF();

  Swal.hideLoading();
  Swal.fire({
    title: 'Fatto!',
    html: "L'immagine &egrave; stata preparata per la stampa.",
    icon: 'success',
    confirmButtonColor: '#278e8e',
  });

  if (canPrintFromFrame()) {
    printFromFrame(pdf.output('bloburl'));
    return;
  }

  pdf.autoPrint();
  window.open(pdf.output('bloburl'), '_blank');
};
